import React, { useEffect } from 'react';
import env from '../../utils/env';
import { trackPageView } from '../../utils/tracking';
import AccountForm from '../AccountForm/AccountForm';
import styles from './CreateAccount.module.css';

function CreateAccount() {
  useEffect(() => {
    trackPageView(window.location.pathname);
  }, []);

  return (
    <>
      <section className={styles.createAccount}>
        <AccountForm />
        <p className={styles.existingAccountText}>
          Already a member?
          {' '}
          <a className={styles.existingAccountLink} href={env.loginUrl}>Log In</a>
        </p>
      </section>
    </>
  );
}

export default CreateAccount;
